import { render, staticRenderFns } from "./cookie-banner-configuration-step.vue?vue&type=template&id=763da2e3&scoped=true"
import script from "./cookie-banner-configuration-step.vue?vue&type=script&lang=js"
export * from "./cookie-banner-configuration-step.vue?vue&type=script&lang=js"
import style0 from "./cookie-banner-configuration-step.vue?vue&type=style&index=0&id=763da2e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763da2e3",
  null
  
)

export default component.exports